/* Men's/Women's size toggle — display only.
   Each size button carries BOTH labels from the server (men's + women's spans,
   women's = men's + 1); which one shows is chosen purely by CSS off the
   `sh-size-womens` class on <html>. Because <html> is never re-rendered, the
   theme's picker re-renders never flash the wrong label — there is no JS in the
   paint path, so there is no timing race to lose.

   JS only: flip the <html> class on toggle, persist the choice, mirror the
   toggle button's aria/active state, and keep the hidden cart line-item
   property (both US sizes) in sync with the selected size. The underlying radio
   `value` (the real US men's variant option value) is NEVER changed. */
(function () {
  var STORAGE_KEY = 'sh_size_mode';

  // Women's = men's + 1 (matches Bedrock/Chaco/Xero and our fit experience).
  // Adds 1 to EVERY number in the value, so it also handles the recrafted parts'
  // ranges/groups/descriptive sizes ("5-6.5" -> "6-7.5", "4/5/6/7" -> "5/6/7/8",
  // "Extra Small (Size 4-6)" -> "Extra Small (Size 5-7)").
  function toWomens(mensValue) {
    if (mensValue == null || !/\d/.test(mensValue)) return mensValue;
    return String(mensValue).replace(/\d+(?:\.\d+)?/g, function (m) {
      return String(parseFloat(m) + 1);
    });
  }

  function currentMode() {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'womens' ? 'womens' : 'mens';
    } catch (e) {
      return 'mens';
    }
  }

  // "Men's 6 / Women's 7". For a pure single size the women's value is capped at
  // 13 (shows "Men's 12" when it would exceed 13); ranges/descriptive sizes are
  // shown as-is (e.g. "Men's 5-6.5 / Women's 6-7.5").
  function dualLabel(mens) {
    var womens = toWomens(mens);
    if (/^\d+(?:\.\d+)?$/.test(mens) && parseFloat(womens) > 13) {
      return "Men's " + mens;
    }
    return "Men's " + mens + " / Women's " + womens;
  }

  function selectedMens(scopeEl) {
    var scope = scopeEl.closest('[data-variant-picker]') || document;
    var field = scope.querySelector('[data-option="size"]');
    var checked = field && field.querySelector('input[type="radio"]:checked');
    return checked ? checked.value : null;
  }

  // Keep in sync with the selected size: the hidden cart line-item property
  // (see variant-picker.liquid) AND the visible "Size: …" display next to the label.
  function syncSelectedSize() {
    document.querySelectorAll('[data-dual-size-input]').forEach(function (input) {
      var mens = selectedMens(input);
      input.value = mens ? dualLabel(mens) : '';
    });
    document.querySelectorAll('[data-size-selected]').forEach(function (el) {
      var mens = selectedMens(el);
      if (mens) { el.textContent = dualLabel(mens); }
    });
  }

  function applyMode(mode) {
    var womens = mode === 'womens';
    document.documentElement.classList.toggle('sh-size-womens', womens);
    document.querySelectorAll('.size-mode-toggle__btn').forEach(function (b) {
      var on = b.getAttribute('data-size-mode') === mode;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    syncSelectedSize();
  }

  function setMode(mode) {
    try { localStorage.setItem(STORAGE_KEY, mode); } catch (e) {}
    applyMode(mode);
  }

  // Delegated listeners survive the theme's picker re-renders — no re-binding.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.size-mode-toggle__btn');
    if (!btn) return;
    setMode(btn.getAttribute('data-size-mode'));
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('input[type="radio"]')) {
      syncSelectedSize();
    }
  });

  // Re-mirror the toggle state and re-sync the cart property once the theme has
  // swapped in the freshly rendered picker. The label swap itself is pure CSS.
  document.addEventListener('variant:changed', function () {
    applyMode(currentMode());
  });

  function init() { applyMode(currentMode()); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
